export default {
      id: "pie-chart-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#pie-chart",
      toString: function () {
        return this.url;
      }
    }